import { render, staticRenderFns } from "./Mappings.vue?vue&type=template&id=764a68ae"
import script from "./Mappings.vue?vue&type=script&lang=js"
export * from "./Mappings.vue?vue&type=script&lang=js"
import style0 from "./Mappings.vue?vue&type=style&index=0&id=764a68ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports